<template>
  <van-uploader class="vg-image-uploader"
                v-bind="$attrs"
                v-on="$listeners">
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </van-uploader>
</template>

<script>
import {Uploader} from 'vant';

export default {
  name: 'VgImageUploader',
  components: {[Uploader.name]: Uploader}
}
</script>

<style scoped>
.vg-image-uploader.maximum.van-uploader {
  width: 100%;
}

.vg-image-uploader.maximum >>> .van-uploader__preview {
  width: 100%;
  aspect-ratio: 16/9;
  min-height: 150px;
  height: auto;
  max-height: 30vh;
  margin: 0;
  border-radius: 10px;
}

.vg-image-uploader.maximum >>> .van-uploader__upload{
  width: 50px;
  height: 50px;
}

.vg-image-uploader.maximum >>> .van-image {
  width: 100%;
  aspect-ratio: 16/9;
  min-height: 150px;
  height: auto;
  max-height: 30vh;
  border-radius: 10px;
}

.vg-image-uploader {
  /*margin: 0 17px 17px;*/
}

.vg-image-uploader.images-only {
  margin-top: 17px
}

.vg-image-uploader >>> .van-uploader__wrapper {
  gap: 10px 20px;
}

.vg-image-uploader.maximum >>> .van-uploader__wrapper {
  justify-content: flex-end;
}

.vg-image-uploader >>> .van-uploader__preview,
.vg-image-uploader >>> .van-uploader__upload{
  width: 80px;
  height: 80px;
}

.vg-image-uploader >>> .van-uploader__mask {
  border-radius: 10px;
}

.vg-image-uploader >>> .van-uploader__upload {
  margin: 0;
  border-radius: 10px;
  box-sizing: border-box;
  border: solid 1px #E7E5E7;
  background-color: #FFFFFF;
}

.vg-image-uploader >>> .van-uploader__preview-image {
  width: inherit;
  height: inherit;
}

.vg-image-uploader >>> .van-uploader__preview-delete {
  background: #FF3434;
  top: -6px;
  right: -8px;
  width: 18px;
  height: 18px;
  border-radius: 9px;
}

.vg-image-uploader >>> .van-uploader__preview-delete-icon {
  font-size: 22px;
}

.vg-image-uploader >>> .van-image__img {
  /*width: 80px;*/
  /*height: 80px;*/
  border-radius: 10px;
}

.vg-image-uploader >>> .van-uploader__wrapper--disabled {
  opacity: inherit;
}

.vg-image-uploader >>> .van-uploader__wrapper--disabled .van-uploader__upload {
  display: none;
}

.vg-image-uploader.full >>> .van-uploader__upload {
  display: none;
}

.vg-image-uploader >>> .van-icon-photograph {
  height: 50%;
  width: 50%;
}

.vg-image-uploader >>> .van-icon-photograph:before {
  content: "";
  display: block;
  position: absolute;
  top:50%;
  width: 100%;
  border-bottom: 1px solid #0B53EF;
}

.vg-image-uploader >>> .van-icon-photograph:after {
  content: "";
  display: block;
  position: absolute;
  left:50%;
  height: 100%;
  border-left: 1px solid #0B53EF;
}

.vg-image-uploader >>> .van-uploader__wrapper--disabled .van-uploader__preview-delete {
  display: none;
}
</style>